import request from '@/utils/request'

const garbage = {
  name: 'garbage',
  state: {
    isGarbageDetailLoading: false,
    garbageDetailData: {}
  },

  mutations: {
    SET_IS_MODULES_GARBAGE_DETAIL_LOADING: (state, data) => {
      state.isGarbageDetailLoading = data
    },
    SET_MODULES_GARBAGE_DETAIL_DATA: (state, data) => {
      state.garbageDetailData = data
    }
  },

  actions: {
    //  获取账号编辑页面数据
    queryGarbageDetailData({ commit }, id) {
      commit('SET_IS_MODULES_GARBAGE_DETAIL_LOADING', true)
      commit('SET_MODULES_GARBAGE_DETAIL_DATA', {})
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/garbage/garbageDetail',
          method: 'post',
          data: { id: id }
        }).then(response => {
          commit('SET_IS_MODULES_GARBAGE_DETAIL_LOADING', false)
          commit('SET_MODULES_GARBAGE_DETAIL_DATA', response.data)
          resolve(response.data)
        }).catch(error => {
          commit('SET_IS_MODULES_GARBAGE_DETAIL_LOADING', false)
          reject(error)
        })
      })
    },
    //  重置账号新增页面数据
    resetGarbageDetailData({ commit }) {
      commit('SET_MODULES_GARBAGE_DETAIL_DATA', {})
    }
  }
}

export default garbage
